import { ValueOf } from './util';

/** 決済種別のenum */
export const EPaymentType = {
  FACE_TO_FACE: '対面決済',
  NON_FACE_TO_FACE_BASIS: '非対面都度決済',
  RENEWAL_BILLING: '継続課金',
  NON_FACE_TO_FACE_CHARGE_OPEN: '非対面チャージ（オープン）',
  NON_FACE_TO_FACE_CHARGE_HOME: '非対面チャージ（ハウス）',
  NON_FACE_TO_FACE_CHARGE_TRANSFER: '非対面チャージ（資金移動）',
} as const;

export type PaymentTypeKey = keyof typeof EPaymentType;
export type PaymentTypeValue = ValueOf<typeof EPaymentType>;

export const paymentTypeKeys = Object.keys(EPaymentType) as (PaymentTypeKey[]);

/** v-select用items */
export const paymentTypeItems = paymentTypeKeys
  .map((key) => ({
    title: EPaymentType[key],
    value: key,
  }));
